/** Shared date helpers for the notification bell and the /notifications page. */

export function relativeTime(iso) {
  if (!iso) return ''
  const then = new Date(iso)
  if (Number.isNaN(then.getTime())) return ''
  const secs = Math.max(0, Math.round((Date.now() - then.getTime()) / 1000))
  if (secs < 60) return 'just now'
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`
  if (secs < 604800) return `${Math.floor(secs / 86400)}d ago`
  return then.toLocaleDateString()
}

export function dayGroup(iso) {
  if (!iso) return 'Earlier'
  const then = new Date(iso)
  if (Number.isNaN(then.getTime())) return 'Earlier'
  const now = new Date()
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  // local midnight, not "now - 24h": a DST change would shift the bucket by an hour
  const startOfYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime()
  if (then.getTime() >= startOfToday) return 'Today'
  if (then.getTime() >= startOfYesterday) return 'Yesterday'
  return 'Earlier'
}

/** [{label, items[]}] in Today / Yesterday / Earlier order, empty groups dropped. */
export function groupNotifications(items) {
  const order = ['Today', 'Yesterday', 'Earlier']
  const buckets = new Map(order.map((label) => [label, []]))
  for (const item of items || []) buckets.get(dayGroup(item.created_at)).push(item)
  return order.filter((label) => buckets.get(label).length).map((label) => ({ label, items: buckets.get(label) }))
}
